import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { UsuarioCreatePage } from '@/pages/usuario-create';

export const Route = createFileRoute('/_private/usuarios/nuevo')({
  beforeLoad: () => exigirAcceso('usuarios'),
  component: UsuarioCreatePage,
});
